<template>
  <div>
    <div class="title-header">
      <h5>{{ 'Genetically Closest Populations' }}</h5>
    </div>
    <div class="dist-table-container">
      <div class="dist-tab"
        v-for="(tab) in $store.state.sampleDatabase.distanceTypes" :key="tab" 
        :class="{ 'active': tab === $store.state.sampleDatabase.distanceType }"
        @click="$store.state.sampleDatabase.distanceType = tab"
      >
        {{ tab }}
      </div>
    </div>
    <div class="distance-container">
      <table class="table table-bordered distance-table">
        <thead>
            <tr>
              <th scope="col">Distance</th>
              <th scope="col">Population</th>
            </tr>
        </thead>
        <tbody v-show="$store.state.sampleDatabase.distanceType === 'Modern'">
          <tr v-for="distanceItem in distanceList" :key="distanceItem.title">
            <td><span class="td-size" :style="{ color: distanceItem.color }"> {{ distanceItem.distance }}</span></td>
            <td>{{$t(distanceItem.title.replaceAll('*', ' '))}}</td>
          </tr>
        </tbody>
        <tbody v-show="$store.state.sampleDatabase.distanceType === 'Ancient'">
          <tr v-for="distanceItem in distanceAncientList" :key="distanceItem.title">
            <td><span class="td-size" :style="{ color: distanceItem.color }"> {{ distanceItem.distance }}</span></td>
            <td>{{$t(distanceItem.title.replaceAll('*', ' '))}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
  },
  computed: {
    distanceList() {
      return this.$store.state.sampleDatabase.calculatedDistance;
    },
    distanceAncientList() {
      return this.$store.state.sampleDatabase.calculatedDistanceAncient;
    },
  },
  mounted() {
  },
};
</script>
